import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export const DEFAULT_PAYOUT_LOOKBACK_DAYS = 30;

export function useCancellationProtectionConfig() {
  return useCbhFlag(CbhFeatureFlag.RELEASE_CANCELLATION_PROTECTION, {
    defaultValue: { enabled: false },
  });
}
